<template>
  <div class="row">
    <div class="small-12 columns">
      <h1 class="mb-5">Edit Coupon</h1>

      <div class="row">
        <div class="small-4 columns">Coupon Name</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.name"
            type="text"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <div class="row">
        <div class="small-4 columns">Coupon Value (Paisa)</div>
        <div class="small-8 columns">
          <small class="text-green-dark">Rs. {{ rupee }}/-</small>
          <input
            v-model="coupon.coupon_value"
            type="number"
            class="input-box-course-creators"
          />
        </div>
      </div>

      <div class="row">
        <div class="small-4 columns">is_automatic</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.is_automatic"
            type="checkbox"
            class="input-box-course-creators"
          />
        </div>
      </div>

      <div class="row">
        <div class="small-4 columns">is_special</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.is_special"
            type="checkbox"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <!--  -->
      <!-- Users[Array] search by email  -->

      <div v-if="coupon.is_special || coupon.is_manual" class="row">
        <div class="small-4 columns"><div>Users</div></div>
        <div class="small-8 columns">
          <VueSelect
            v-model="coupon.users"
            multiple
            :searchable="true"
            :options="usersOptions"
            label="email"
            @search="getUsers"
          />
        </div>
      </div>

      <div class="row my-3">
        <div class="small-4 columns"><div>Cohorts</div></div>
        <div class="small-8 columns">
          <VueSelect
            v-model="coupon.cohorts"
            multiple
            :searchable="true"
            :options="cohortsOptions"
            label="name"
          />
        </div>
      </div>

      <div class="row mt-8">
        <div class="small-4 columns"><div>Question Bank Cohorts</div></div>
        <div class="small-8 columns">
          <VueSelect
            v-model="coupon.question_bank_cohorts"
            multiple
            :searchable="true"
            :options="questionBankCohortOptions"
            :closeOnSelect="false"
            label="name"
          />
        </div>
      </div>

      <div v-if="coupon.cut_off" class="row cutoff-container mb-12 mt-8">
        <h3>Add Groups for the selected question-bank cohorts</h3>
        <div
          v-for="(item, i) in coupon.question_bank_cohorts"
          :key="i"
          class="my-3"
        >
          <div class="small-4 columns">{{ item.name }}</div>
          <div class="small-8 columns">
            <VueSelect
              v-model="item.cohort_groups"
              multiple
              :searchable="true"
              :closeOnSelect="false"
              :options="getCohortGroups(item.id)"
              v-validate="'required'"
              label="name"
              name="Groups"
            />
          </div>
        </div>
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("Groups") }}
        </small>
      </div>

      <!--  -->
      <!-- Coupon JSON -->
      <!--  -->
      <div v-if="coupon.cut_off" class="row cutoff-container">
        <h3>Cut Off</h3>
        <div class="small-4 columns">Game Cut Off</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.cut_off.game"
            type="text"
            class="input-box-course-creators"
          />
        </div>

        <div class="small-4 columns">Code Cut Off</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.cut_off.code"
            type="text"
            class="input-box-course-creators"
          />
        </div>

        <div class="small-4 columns">MCQ Cut Off</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.cut_off.mcq"
            type="text"
            class="input-box-course-creators"
          />
        </div>

        <div class="small-4 columns">Video Cut Off</div>
        <div class="small-8 columns">
          <input
            v-model="coupon.cut_off.video"
            type="text"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <!--  -->
      <!-- END OF COUPON JSON -->
      <div class="row">
        <div class="small-12 columns">
          <button class="button-green" @click="addCoupon">Edit Coupon</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { VueSelect },
  data() {
    return {
      coupon: {
        name: "",
        coupon_value: 0,
        is_automatic: false,
        cohorts: [],
        is_special: false,
        is_manual: false,
        users: [],
        question_bank_cohorts: [],
      },
      usersOptions: [],
      cohortsOptions: [],
      questionBankCohortOptions: [],
    }
  },
  computed: {
    rupee() {
      return this.coupon.coupon_value / 100
    },
  },
  created() {
    this.getCohorts()
    this.getQuestionBankCohorts()
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}coupons/${this.$route.params.coupon_id}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(res => {
      const payload = res.data.data
      this.coupon = payload
      window.pageTitle = `Edit - ${this.coupon.name}`
    })
  },
  methods: {
    debouncer() {
      return window._.debounce(this.makeRequest, 2000)
    },
    makeRequest(text) {
      // console.log(text);
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}users/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        params: { search_text: text },
      }).then(res => {
        this.usersOptions = res.data.users
      })
    },
    getUsers(text) {
      this.debouncer(text)(text)
    },
    getCohorts() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}cohorts/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.cohortsOptions = res.data.items
      })
    },
    getCohortGroups(cohort_id) {
      if (this.questionBankCohortOptions) {
        for (let i = 0; i < this.questionBankCohortOptions.length; i++) {
          if (this.questionBankCohortOptions[i].id == cohort_id) {
            return this.questionBankCohortOptions[i].groups
          }
        }
      }
      return []
    },
    getQuestionBankCohorts() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}question_bank/cohorts?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.questionBankCohortOptions = res.data.items.map(item => ({
          id: item.id,
          name: item.name,
          groups: item.groups,
        }))
      })
    },
    addCoupon() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fill all the required fields marked with *")
          return
        }

        const users =
          this.coupon.users.length > 0
            ? this.coupon.users.map(item => item.id)
            : []
        const cohorts =
          this.coupon.cohorts.length > 0
            ? this.coupon.cohorts.map(item => item.id)
            : []
        const question_bank_cohorts =
          this.coupon.question_bank_cohorts.length > 0
            ? this.coupon.question_bank_cohorts.map(item => ({
                id: item.id,
                name: item.name,
                cohort_groups: item.cohort_groups,
              }))
            : []
        const payload = {
          name: this.coupon.name,
          is_special: this.coupon.is_special,
          coupon_value: this.coupon.coupon_value,
          users,
          cohorts,
          question_bank_cohorts,
          is_automatic: this.coupon.is_automatic || false,
        }

        this.axios({
          method: "put",
          url: `${siteConfig.siteURL}coupons/${this.$route.params.coupon_id}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
          data: payload,
        }).then(() => {
          this.$router.push("/coupons/")
        })
      })
    },
  },
}
</script>

<style>
.cutoff-container {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #cac7c7;
  background-color: #efefef;
}
</style>
